import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const CloseIcon: React.FC<IconProps> = props => (
  <Icon fill="currentColor" {...props}>
    <path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z" />
  </Icon>
)
